//Form
import { Formik, useField, Form } from "formik";
import * as Yup from "yup";

import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import { cartActions } from "../../store/cartSlice";
import classes from "./InquireSelect.module.css";
import { ButtonPrimary } from "../../components/Button/Button";
import { useState } from "react";

const InquireSelect = () => {
  // const
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartData = useSelector((state) => state.cart.items);

  //Formik
  const MySelect = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    return (
      <div>
        <label htmlFor={props.id || props.name}>{label}</label>
        <select {...field} {...props} />
        {meta.touched && meta.error ? (
          <div className={classes.error}>{meta.error}</div>
        ) : null}
      </div>
    );
  };

  const formContent = (
    <Form className={classes.selectList}>
      <h4>. . .還有幾個問題想請問你🤓</h4>
      <div className={classes.selectListWrapper}>
        <MySelect name="type" className={classes.selectList__item}>
          <option value="">您的活動性質</option>
          <option value="性質1">性質1</option>
          <option value="性質2">性質2</option>
          <option value="性質3">性質3</option>
          <option value="單純詢問">單純詢問</option>
        </MySelect>
        <MySelect name="price" className={classes.selectList__item}>
          <option value="">您的預算區間</option>
          <option value="預算區間1">預算區間1</option>
          <option value="預算區間2">預算區間2</option>
          <option value="預算區間3">預算區間3</option>
          <option value="單純詢問">單純詢問</option>
        </MySelect>
        <MySelect name="time" className={classes.selectList__item}>
          <option value="">您的時間交期</option>
          <option value="時間交期1">時間交期1</option>
          <option value="時間交期2">時間交期2</option>
          <option value="時間交期3">時間交期3</option>
          <option value="單純詢問">單純詢問</option>
        </MySelect>
        {/* <span className={classes.other}>其他備註</span> */}
        <ButtonPrimary
          className={classes.button}
          text="馬上諮詢"
          type="submit"
        />
      </div>
    </Form>
  );

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: "0.1" } }}
      className={classes.inquire}
    >
      <Formik
        initialValues={{ type: "", price: "", time: "" }}
        validationSchema={Yup.object({
          type: Yup.string()
            .oneOf(["性質1", "性質2", "性質3", "單純詢問"], "必填")
            .required("必填"),
          price: Yup.string()
            .oneOf(["預算區間1", "預算區間2", "預算區間3", "單純詢問"], "必填")
            .required("必填"),
          time: Yup.string()
            .oneOf(["時間交期1", "時間交期2", "時間交期3", "單純詢問"], "必填")
            .required("必填"),
        })}
        onSubmit={(values, { setSubmitting }) => {
          console.log(cartData, values);
          navigate("inquire-successful", { replace: true });
          dispatch(cartActions.clear());
          // setIsLoading(true);
          // const status = firebasePost("LOGIN", {
          //   email: values.email,
          //   password: values.password,
          // });
          // if (status === "SUCCESS") setIsLoading(false);
        }}
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: "0.1" } }}
        >
          {formContent}
        </motion.div>
      </Formik>
    </motion.div>
  );
};

export default InquireSelect;
